(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chai-cart"]) return;
  try {
    
  for (const button of document.querySelectorAll('[data-ck-upgrade]')) {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-ck-upgrade-status]');
      button.disabled = true;
      status.textContent = 'Upgrading your chai pack…';
      try {
        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.targetId), quantity: 1 }] })
        });
        if (!addResponse.ok) throw new Error('We could not add the larger pack. Your cart has not changed.');
        const removeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: button.dataset.currentKey, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error('The larger pack was added. Please remove the smaller pack before checkout.');
        window.location.reload();
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      }
    });
  }
  for (const button of document.querySelectorAll('[data-ck-add-bump]')) {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-ck-add-status]');
      button.disabled = true;
      status.textContent = 'Adding gift-ready details…';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.targetId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('We could not add this option. Your cart has not changed.');
        window.location.reload();
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chai-product"]) return;
  try {
    
  for (const section of document.querySelectorAll('.ck-pdp[data-section-id]')) {
    const form = section.querySelector('.ck-product-form');
    const variantInput = section.querySelector('[data-ck-variant-id]');
    const prices = section.querySelectorAll('[data-ck-price]');
    const buttonPrice = section.querySelector('[data-ck-button-price]');
    const submitLabel = section.querySelector('[data-ck-submit-label]');
    const packLabel = section.querySelector('[data-ck-pack-label]');
    const submit = section.querySelector('[data-ck-submit]');
    const mobileSubmit = section.querySelector('[data-ck-mobile-submit]');
    const status = section.querySelector('[data-ck-status]');
    const mainImage = section.querySelector('[data-ck-main-image]');
    for (const radio of section.querySelectorAll('input[name="ck-pack"]')) {
      radio.addEventListener('change', () => {
        const available = radio.dataset.available === 'true';
        variantInput.value = radio.value;
        for (const price of prices) price.textContent = radio.dataset.price;
        if (buttonPrice) buttonPrice.textContent = radio.dataset.price;
        if (packLabel) packLabel.textContent = radio.dataset.label;
        submit.disabled = !available;
        if (mobileSubmit) mobileSubmit.disabled = !available;
        if (submitLabel) submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
        if (mobileSubmit) mobileSubmit.textContent = available ? 'Add to cart' : 'Sold out';
        for (const option of section.querySelectorAll('.ck-pack-option')) option.classList.remove('is-selected');
        radio.closest('.ck-pack-option')?.classList.add('is-selected');
        const url = new URL(window.location.href); url.searchParams.set('variant', radio.value); window.history.replaceState({}, '', url);
      });
    }
    for (const thumb of section.querySelectorAll('[data-ck-image]')) {
      thumb.addEventListener('click', () => {
        if (mainImage) { mainImage.src = thumb.dataset.ckImage; mainImage.alt = thumb.dataset.ckAlt; }
        for (const image of section.querySelectorAll('[data-ck-image]')) image.classList.remove('is-active');
        thumb.classList.add('is-active');
      });
    }
    form?.addEventListener('submit', async (event) => {
      event.preventDefault(); submit.disabled = true; if (mobileSubmit) mobileSubmit.disabled = true; status.textContent = 'Adding your chai…';
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add this pack right now. Please try again.');
        const [drawerResponse, cartResponse] = await Promise.all([fetch(`${window.Shopify.routes.root}?sections=cart-drawer-section`), fetch(`${window.Shopify.routes.root}cart.js`)]);
        const sectionsJson = await drawerResponse.json(); const currentDrawer = document.querySelector('#shopify-section-cart-drawer-section');
        if (currentDrawer && sectionsJson['cart-drawer-section']) currentDrawer.outerHTML = sectionsJson['cart-drawer-section'];
        const cartJson = await cartResponse.json(); for (const count of document.querySelectorAll('.cart-bubble__text-count')) count.textContent = cartJson.item_count;
        status.textContent = 'Added to your cart.'; document.querySelector('#cart-drawer')?.open();
      } catch (error) { status.textContent = error.message; }
      finally { submit.disabled = false; if (mobileSubmit) mobileSubmit.disabled = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
